export default function initImageScale() {
  const imageHolders = document.querySelectorAll('.image-scale');
  if (imageHolders.length === 0) return;

  const activeClass = 'active';
  const animatedItems = new Set(); // To prevent re-adding the class

  const observer = new IntersectionObserver(
    (entries) => {
      // Filter only intersecting and not yet animated items
      const newEntries = entries.filter((entry) => entry.isIntersecting && !animatedItems.has(entry.target));

      newEntries.forEach((entry, index) => {
        const delay = index * 150; // 150ms stagger delay
        setTimeout(() => {
          entry.target.classList.add(activeClass);
          animatedItems.add(entry.target);
        }, delay);
      });
    },
    {
      threshold: 0.5,
    }
  );

  imageHolders.forEach((holder) => observer.observe(holder));
}
